var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex flex-col min-h-screen overflow-hidden"},[_c('Header'),_c('main',{staticClass:"flex-grow"},[_c('PricingTables'),_c('TestimonialsCarousel'),_c('Faqs'),_c('Cta')],1),_c('Footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }